module.exports = __webpack_public_path__ + "assets/img/download.54328842.svg";